module.exports = __webpack_public_path__ + "img/57000.afd25498.jpg";